var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAv5ButtonArrow = function SvgAv5ButtonArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "circle-part",
    "data-no-fill": "true",
    d: "M17.25 9A8.25 8.25 0 1 1 .75 9a8.25 8.25 0 0 1 16.5 0Z",
    stroke: "#002774",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "arrow-part",
    "data-no-stroke": "true",
    d: "M7.5 13 12 8.77 7.5 5.01",
    stroke: "#002774",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgAv5ButtonArrow as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTggMTgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cGF0aCBjbGFzcz0iY2lyY2xlLXBhcnQiIGRhdGEtbm8tZmlsbD0idHJ1ZSIgZD0iTTE3LjI1IDlDMTcuMjUgMTMuNTU2MyAxMy41NTYzIDE3LjI1IDkgMTcuMjVDNC40NDM2NSAxNy4yNSAwLjc1IDEzLjU1NjMgMC43NSA5QzAuNzUgNC40NDM2NSA0LjQ0MzY1IDAuNzUgOSAwLjc1QzEzLjU1NjMgMC43NSAxNy4yNSA0LjQ0MzY1IDE3LjI1IDlaIgogICAgICAgICAgc3Ryb2tlPSIjMDAyNzc0IiBzdHJva2Utd2lkdGg9IjEuNSIvPgogICAgPHBhdGggY2xhc3M9ImFycm93LXBhcnQiIGRhdGEtbm8tc3Ryb2tlPSd0cnVlJyBkPSJNNy41IDEzTDEyIDguNzcwMTFMNy41IDUuMDEwMjIiIHN0cm9rZT0iIzAwMjc3NCIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIKICAgICAgICAgIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";